import * as Config from '../../../../../config';
import React from 'react';
import { connect } from "react-redux";

import Menu from '../../../tab-bar/Menu';

function ConnectedTabBarMenus({ isConnected }) {
  return (
    <>
      <Menu to={`/home`} order={1} title={`Discover`} description={`Browse all genres by top tracks, DJ sets, DJ charts, ${Config.capAppName()} playlists, trending artists, trending labels and trending genres.`} />
      <Menu to={`/genres`} order={2} title={`Genres`} description={`Browse by genre: View top tracks in genre, ${Config.capAppName()} playlists in genre, trending artists in genre and trending labels in genre. Filter by favorite genres, featured releases in genre, all tracks in genre, all releases in genre and all playlists in genre.`} />
      <Menu to={`/featured-playlists`} order={3} title={`Playlists`} description={`Browse ${Config.capAppName()} Playlists.`} />
      {/* <Menu to={`/the20`} order={4} title={`The20`} description={`Browse The20.`} /> */}
      {/* { isConnected &&  <Menu to={`/collection`} order={6} title={`Collection`} description={`Your Purchased Collection.`} /> } */}
    </>
  )
}


const TabBarMenus = connect(
  state => ({
    isConnected: state.isConnected
  })
)(ConnectedTabBarMenus);

export default TabBarMenus;
